import { render, staticRenderFns } from "./materiel-detail.vue?vue&type=template&id=1b5b49ef"
import script from "./materiel-detail.vue?vue&type=script&lang=js"
export * from "./materiel-detail.vue?vue&type=script&lang=js"
import style0 from "./materiel-detail.vue?vue&type=style&index=0&id=1b5b49ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports